var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { headerButtonView } from '../HeaderButtons/buttonsView';
export var Container = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"])));
export function getExtraDimHeaderButton(view) {
    switch (view) {
        case 'white':
            return headerButtonView['white'];
        case 'black':
            return headerButtonView['black'];
        default:
            return 'extra-dim';
    }
}
export function getPrimaryDimHeaderButton(view) {
    switch (view) {
        case 'white':
            return headerButtonView['white-dim'];
        case 'black':
            return headerButtonView['black-dim'];
        default:
            return 'primary-dim';
    }
}
var templateObject_1;
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/styles.js
// module id = 1373
// module chunks = 118